var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-btn-bai-mobile",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../../../assets/images/mobile/back_bai.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }